export const getEnv = () => ({
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_URL: process.env.REACT_APP_URL,
  REACT_APP_PUSH_SERVER_PUBLIC_KEY: process.env.REACT_APP_PUSH_SERVER_PUBLIC_KEY,
  ISSUER_SYS_NAME: process.env.REACT_APP_DEFAULT_ISSUER,
});
